import React, {FC} from "react";
import {Button, ColorPicker, Input, Space} from "antd";
import {HEX_COLOR_PATTERN, normalizeHexColor, textValue} from "./eventConfigPayloads";
import "./eventConfig.css";

type HexColorInputProps = {
    value?: string;
    onChange?: (value: string) => void;
    placeholder: string;
    openPickerLabel: string;
    disabled?: boolean;
};

export const HexColorInput: FC<HexColorInputProps> = ({value, onChange, placeholder, openPickerLabel, disabled}) => {
    const currentValue = textValue(value);
    const normalizedValue = normalizeHexColor(currentValue);
    const pickerValue = HEX_COLOR_PATTERN.test(normalizedValue) ? normalizedValue : placeholder;

    const handlePickerChange = (color: { toHexString: () => string }) => {
        onChange?.(normalizeHexColor(color.toHexString()));
    };

    const handleInputBlur = () => {
        const normalized = normalizeHexColor(currentValue);
        if (normalized !== currentValue) {
            onChange?.(normalized);
        }
    };

    return (
        <Space.Compact block>
            <ColorPicker
                value={pickerValue}
                format="hex"
                disabledAlpha
                disabled={disabled}
                onChange={handlePickerChange}
            >
                <Button
                    aria-label={openPickerLabel}
                    disabled={disabled}
                    icon={<span aria-hidden="true" className="event-config__color-swatch" style={{backgroundColor: pickerValue}}/>}
                />
            </ColorPicker>
            <Input
                value={currentValue}
                placeholder={placeholder}
                disabled={disabled}
                onChange={event => onChange?.(event.target.value)}
                onBlur={handleInputBlur}
                className="event-config__hex-input"
            />
        </Space.Compact>
    );
};
